/* eslint-disable */
// this is an auto generated file. This will be overwritten

export var getUsers = "query GetUsers($email: AWSEmail!) {\n  getUsers(email: $email) {\n    email\n    mapOptions\n  }\n}\n";
export var listUsers = "query ListUsers(\n  $filter: TableUsersFilterInput\n  $limit: Int\n  $nextToken: String\n) {\n  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {\n    items {\n      email\n      mapOptions\n    }\n    nextToken\n  }\n}\n";